import manageJss from "@microsoft/fast-jss-manager-react";
import { PivotStyles } from "@microsoft/fast-components-styles-msft";
import pivotSchema from "./pivot.schema";
import pivotSchema2 from "./pivot.schema.2";
import MSFTPivot from "./pivot";
const Pivot = manageJss(PivotStyles)(MSFTPivot);
export { Pivot, pivotSchema, pivotSchema2, };
